<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pi_inoutno }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="pi_date">
            <label class="weui-form-preview__label">{{
              customLabel.pi_date || "单据日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pi_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pi_iocode"
            v-if="form.main.pi_iocode"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_iocode || "售后维修单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_iocode
            }}</span>
          </div>
          <div class="weui-form-preview__item weui-cell" slot="pr_code">
            <label class="weui-form-preview__label">{{
              customLabel.pr_code || "产品编号"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.pr_code }}
            </span>
          </div>
          <div class="weui-form-preview__item weui-cell" slot="pr_detail">
            <label class="weui-form-preview__label">{{
              customLabel.pr_detail || "产品名称"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.pr_detail }}
            </span>
          </div>
          <div
            class="weui-form-preview__item weui-cell"
            slot="pi_departmentname"
            v-if="form.main.pi_departmentname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_departmentname || "部门名称"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.pi_departmentname }}
            </span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pd_pdno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pd_prodcode">
              <label class="weui-form-preview__label">{{
                customLabel.pd_prodcode || "物料编号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "物料名称"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_detail
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_orispeccode"
              v-if="item.productDTO.pr_orispeccode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_outqty"
              v-if="item.pd_outqty"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_outqty || "数量"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_outqty }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_unit"
              v-if="item.productDTO.pr_unit"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_unit || "单位"
              }}</label>
              <span class="weui-form-preview__value">{{ item.productDTO.pr_unit }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_qty_extra" v-if="item.pd_qty_extra">
              <label class="weui-form-preview__label">{{
                customLabel.pd_qty_extra || "辅助数量"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_qty_extra
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_whname">
              <label class="weui-form-preview__label">{{
                customLabel.pd_whname || "仓库"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_whname }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_batchcode"
              v-if="item.pd_batchcode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_batchcode || "批次号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_batchcode
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_madetime"
              v-if="item.pd_madetime"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_madetime || "生产日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                dateFormat(item.pd_madetime, "yyyy-MM-dd")
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_shelflife"
              v-if="item.pd_shelflife"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_shelflife || "保质期(天)"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_shelflife
              }}</span>
            </div>
             <div
              class="weui-form-preview__item"
              slot="pd_lifedate"
              v-if="item.pd_lifedate"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_lifedate || "保质期"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_lifedate
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_price"
              v-if="item.pd_price"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_price || "成本单价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_price }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_total"
              v-if="item.pd_total"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_total || "金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_total }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_remark"
              v-if="item.pd_remark"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_remark }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">总金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_costtotal
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_remark
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/crm/after_sale_pick_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "AfterSalePick",
      xtype: "sale-afterSalePick-formpanel",
    };
  },
};
</script>